import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { GlobalFunctionsService } from '@_services/global-functions.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subject, takeUntil } from 'rxjs';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-lookups',
  templateUrl: './lookups.component.html',
  styleUrls: ['./lookups.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LookupsComponent implements OnInit, OnDestroy {
  confirmDialogRef: MatDialogRef<any>;
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  highlightedRows: any;
  formAction: any;
  isspiner: boolean = false;
  isLoadingResults: boolean = false;
  theme_type: string | null = localStorage.getItem('theme_type');
  appPermissions: any = JSON.parse(localStorage.getItem('app_permissions'));
  selectedColore: string = 'var(--highlighted-bg-row)';
  lookupsData: any;
  lookupsDataSource: any = [];
  lookupguidVal: any = '';
  isNewLookup: boolean = false;
  lookupTupe: any = '';
  displayedColumns: string[] = ['Action', 'name'];
  title: string = 'angular-mat-table-example';
  ExpandDivFlag: boolean = true;
  LookupObjectData: any = {
    LOOKUPGUID: '',
    LOOKUPTYPE: '',
    LOOKUPFULLVALUE: '',
  };
  LookupObjectDataDuplicate: any = {
    LOOKUPGUID: '',
    LOOKUPTYPE: '',
    LOOKUPFULLVALUE: '',
  };
  DATAVAL: any;
  maintainFlag: boolean = false;
  lookupInitialValue: any;
  BooleanData: any;
  ShowDuplicateBotton: boolean = false;
  Lookupdata: any;
  class: any;
  @ViewChild(MatTable) table: MatTable<any>;
  isExpandedRow = (_index: number, row: any): boolean => !!row?.expanded;
  private _unsubscribeAll$: Subject<void> = new Subject();
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    public _matDialog: MatDialog,
    private toastr: ToastrService,
    private behaviorService: BehaviorService,
    public globalFunService: GlobalFunctionsService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingLookupsComponent');
    this.behaviorService.APIretryCall$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (result: any) => {
        if (
          localStorage.getItem('istrackid') == 'SystemSettingLookupsComponent' &&
          result['click'] &&
          result['data']['lookup']
        ) {
          this.saveLookups();
        }
        this.cd.markForCheck();
      },
    });
  }

  ngOnInit() {
    this.behaviorService.permissionCheckforHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (data: any) => {
          this.class = data;
          this.cd.markForCheck();
        },
      });
    this.loadData('Lookup Types');
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to toggle the row data value
   */
  toggleRow(element: any) {
    this.ShowDuplicateBotton = false;
    this.DATAVAL = element.LOOKUPFULLVALUE;
    this.BooleanData = element;
    this.maintainFlag = false;
    if (element.expanded == true) {
      element.expanded = !element.expanded;
    } else {
      this.lookupsDataSource.forEach((row: any) => {
        row.expanded = false;
      });
      element.expanded = !element.expanded;
    }
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  /**
   * This function is used to Add the duplicate data value
   */
  AddDuplicateData() {
    this.DATAVAL = this.Lookupdata;
    this.maintainFlag = false;
    this.ShowDuplicateBotton = false;
    this.lookupsDataSource.forEach((row: any) => {
      row.expanded = false;
    });
    setTimeout(() => {
      this.lookupsDataSource.forEach((row: any) => {
        if (row.LOOKUPGUID != this.LookupObjectData.LOOKUPGUID) {
          row.expanded = false;
        } else {
          this.ShowDuplicateBotton = true;
          this.LookupObjectData.expanded = true;
        }
      });
      this.table?.renderRows();
      this.cd.markForCheck();
    }, 300);
    this.cd.markForCheck();
  }

  /**
   * This funcion is used to load the data value
   */
  loadData(type: any) {
    this.lookupTupe = type == 'Lookup Types' ? '' : type;
    this.behaviorService.loadingSystemSetting(null);
    this.isLoadingResults = true;
    this._mainAPiServiceService
      .getSetData({ Action: 'getdata', Filters: { LookupType: type } }, 'lookup')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (responses: any) => {
          if (responses.CODE == 200 && responses.STATUS == 'success') {
            if (type == 'Lookup Types') {
              this.lookupsData = responses.DATA.LOOKUPS;
              // localStorage.setItem('matter_desc_lookups', JSON.stringify(responses.DATA.LOOKUPS));
              if (responses.DATA.LOOKUPS[0]) {
                this.lookupguidVal = responses.DATA.LOOKUPS[0]['LOOKUPGUID'];
                this.loadData(responses.DATA.LOOKUPS[0]['LOOKUPGUID']);
                responses.DATA.LOOKUPS[0]['expanded'] = false;
              }
            } else {
              const data = responses.DATA.LOOKUPS;
              if (type == 'Matter Deliverable') {
                localStorage.setItem('Deliverable_lookups_list', JSON.stringify(data));
              }
              if (data.length > 0) {
                data.forEach((element: any) => {
                  element['expanded'] = false;
                  this.lookupsDataSource = responses.DATA.LOOKUPS;
                });
              } else {
                this.lookupsDataSource = [];
              }
              if (type == 'Matter Desc') {
                localStorage.setItem('matter_desc_lookups', JSON.stringify(responses.DATA.LOOKUPS));
              }

              if (type == 'Entity Type') {
                localStorage.setItem(
                  'client_entity_lookups',
                  JSON.stringify(responses.DATA.LOOKUPS),
                );
              }
              if (responses.DATA.LOOKUPS[0]) {
                this.editLookups(responses.DATA.LOOKUPS[0]);
                this.DATAVAL = responses.DATA.LOOKUPS[0].LOOKUPFULLVALUE;
              }
            }
            this.behaviorService.loadingSystemSetting('lookups');
          }
          this.isLoadingResults = false;
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isLoadingResults = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This funcion is used to edit the lookups value
   */
  editLookups(row: any) {
    //this.DATAVAL=row.LOOKUPFULLVALUE;
    this.Lookupdata = row.LOOKUPFULLVALUE;
    this.LookupObjectData = row;
    this.highlightedRows = row.LOOKUPGUID;
    this.maintainFlag = false;
    this.cd.markForCheck();
  }

  /**
   * this function is used to get the new lookup
   */
  newLokkup() {
    this.isNewLookup = true;
    this.LookupObjectData = {
      LOOKUPGUID: '',
      LOOKUPTYPE: this.lookupTupe,
      LOOKUPFULLVALUE: '',
    };
    this.cd.markForCheck();
  }

  /**
   * This function is used to save the lookups
   */
  saveLookups(data?: any) {
    this.isspiner = true;
    if (this.LookupObjectData.LOOKUPGUID == '') {
      delete this.LookupObjectData['LOOKUPGUID'];
      this.formAction = 'insert';
    } else if (data == 'DUPLICATE') {
      this.formAction = 'insert';
      delete this.LookupObjectData.expanded;
      this.LookupObjectData.LOOKUPFULLVALUE = this.DATAVAL;
      // delete this.LookupObjectData.LOOKUPGUID;
    } else {
      this.formAction = 'update';
      this.lookupInitialValue = this.LookupObjectData.LOOKUPFULLVALUE;
      this.LookupObjectData.LOOKUPFULLVALUE = this.DATAVAL;
      delete this.LookupObjectData.expanded;
    }
    let LookupData: any = {
      Action: this.formAction,
      VALIDATEONLY: true,
      DATA: this.LookupObjectData,
    };
    this._mainAPiServiceService
      .getSetData(LookupData, 'lookup')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          LookupData.VALIDATEONLY = true;
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.checkValidation(response.DATA.VALIDATIONS, LookupData);
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            if (this.formAction == 'update') {
              this.LookupObjectData.LOOKUPFULLVALUE = this.lookupInitialValue;
            }
            this.checkValidation(response.DATA.VALIDATIONS, LookupData);
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            if (this.formAction == 'update') {
              this.LookupObjectData.LOOKUPFULLVALUE = this.lookupInitialValue;
            }
            this.checkValidation(response.DATA.VALIDATIONS, LookupData);
          }
          this.isspiner = false;
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
  // checkValidation(bodyData: any, details: any) {
  //   let errorData: any = [];
  //   let warningData: any = [];
  //   let tempError: any = [];
  //   let tempWarning: any = [];
  //   bodyData.forEach(function (value: { VALUEVALID: string; ERRORDESCRIPTION: any; FIELDNAME: any; }) {
  //     if (value.VALUEVALID == 'No') {
  //       errorData.push(value.ERRORDESCRIPTION);
  //       tempError[value.FIELDNAME] = value;
  //     } else if (value.VALUEVALID == 'Warning') {
  //       tempWarning[value.FIELDNAME] = value;
  //       warningData.push(value.ERRORDESCRIPTION);
  //     }
  //   });
  //   this.errorWarningData = { "Error": tempError, 'warning': tempWarning };
  //   if (Object.keys(errorData).length != 0) {
  //     this.toastr.error(errorData);
  //     this.isspiner = false;
  //   } else if (Object.keys(warningData).length != 0) {
  //     this.isspiner = false;
  //     this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
  //       disableClose: true,
  //       width: DIALOG_WIDTH.FULL,
  //       data: warningData
  //     });
  //     this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to Save?';
  //     this.confirmDialogRef.afterClosed().subscribe(result => {
  //       if (result) {
  //         this.isspiner = true;
  //         this.saveLookupData(details);
  //       }
  //       this.confirmDialogRef = null;
  //     });
  //   } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
  //     this.saveLookupData(details);

  //   }
  // }
  /**
   * This function is used to check the validation
   */
  async checkValidation(bodyData: any, PostActivityData: any, ApiName?: any) {
    this.isspiner = false;
    await this.globalFunService
      .checkValidation(bodyData, PostActivityData)
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.errorWarningData = data.errorWarningData;
            //this.errorWarningDataArray = data.errorWarningData;
            if (data.callback) {
              this.saveLookupData(PostActivityData);
            }
          }
          this.cd.markForCheck();
        },
        error: (err: any) => {
          console.error(err);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This function is used to save the lookups
   */
  saveLookupData(data: any) {
    data.VALIDATEONLY = false;
    this._mainAPiServiceService
      .getSetData(data, 'lookup')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            if (this.formAction != 'insert') {
              this.toastr.success('Lookups updated successfully');
            } else {
              this.toastr.success('Lookups saved successfully');
            }
            this.loadData(data?.DATA?.LOOKUPTYPE);
            this.LookupObjectData = {
              LOOKUPGUID: '',
              LOOKUPTYPE: '',
              LOOKUPFULLVALUE: '',
            };
            this.isNewLookup = false;
            this.isspiner = false;
            this.maintainFlag = false;
          } else if (response.CODE == 451 && response.STATUS == 'warning') {
            this.toastr.warning(response.MESSAGE);
            this.isspiner = false;
          } else if (response.CODE == 450 && response.STATUS == 'error') {
            this.toastr.error(response.MESSAGE);
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.isspiner = false;
          this.cd.markForCheck();
        },
      });
  }

  /**
   * This function is used to delete the lookups
   */
  DeleteLookups() {
    let confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
    });
    confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    confirmDialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result) {
          this._mainAPiServiceService
            .getSetData(
              {
                Action: 'delete',
                VALIDATEONLY: false,
                DATA: {
                  LOOKUPGUID: this.LookupObjectData.LOOKUPGUID,
                  LOOKUPTYPE: this.LookupObjectData.LOOKUPGUID,
                },
              },
              'lookup',
            )
            .subscribe({
              next: (response: any) => {
                if (
                  response.CODE == 200 &&
                  (response.STATUS == 'OK' || response.STATUS == 'success')
                ) {
                  this.toastr.success('Lookups deleted successfully');
                  this.loadData(this.LookupObjectData.LOOKUPTYPE);
                }
                this.cd.markForCheck();
              },
              error: (error: any) => {
                console.error(error);
                this.cd.markForCheck();
              },
            });
        }
        confirmDialogRef = null;
        this.cd.markForCheck();
      },
    });
  }
  newDemo() {
    // this.lookupsDataSource.unshift({
    //   LOOKUPGUID:'',
    //   LOOKUPTYPE:'',
    //   LOOKUPFULLVALUE:'',
    //   expanded:true
    // })
  }

  /**
   * This function is used to get the value data
   */
  async getValue() {
    await this.newLokkup();
    this.maintainFlag = true;
    this.lookupsDataSource.forEach((row: any) => {
      row.expanded = false;
    });
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  /**
   * This function is used to dont save the data value
   */
  dontSave() {
    this.lookupsDataSource.forEach((row: any) => {
      row.expanded = false;
    });
    this.table?.renderRows();
    this.cd.markForCheck();
  }

  /**
   * This function is used to collaps Expanded row
   */
  CollapstExpandedrow() {
    this.LookupObjectData.expanded = false;
    this.table?.renderRows();
    this.cd.markForCheck();
  }
}
